module.exports = __webpack_public_path__ + "../resources/img/ic_re_delete_default.c838b6f1.svg";